import { connect } from "react-redux";
import TestsPresentationComponent from "../../components/one-back/presenter";
import {
  nextTask,
  nextTest,
  setShowTaskCompletion,
  markTaskResultsStart,
  markTaskResultsEnd,
  addTaskResultDetails,
} from "../../actions/index";

const stateToProps = (state) => {
  const {
    currentTask: { testIndex },
    tasks: {
      oneBack: { tests },
    },
  } = state;
  return {
    tests,
    testIndex,
    timeToHit: 1.2,
  };
};

const dispatchProps = {
  nextTest,
  setShowTaskCompletion,
  markTaskResultsStart,
  markTaskResultsEnd,
  addTaskResultDetails,
};

const mergeProps = (
  stateProps,
  {
    nextTest: boundNextTest,
    setShowTaskCompletion: boundSetShowTaskCompletion,
    markTaskResultsStart: boundMarkTaskResultsStart,
    markTaskResultsEnd: boundMarkTaskResultsEnd,
    addTaskResultDetails: boundAddTaskResultDetails,
  },
  otherProps
) => {
  const { testIndex, tests } = stateProps;
  const lastTest = testIndex == tests.length - 1;
  const next = () =>
    setTimeout(
      () => {
        if (lastTest) {
          boundMarkTaskResultsEnd();
          boundSetShowTaskCompletion(true, nextTask());
        } else {
          boundNextTest();
        }
      },

      1000
    );
  const handleStart = () => boundMarkTaskResultsStart();
  const handleHit = (reactionTime, tapDuration) => {
    boundAddTaskResultDetails({ response: "hit", reactionTime, tapDuration });
    next();
  };

  const handleTimeout = () => {
    boundAddTaskResultDetails({
      response: "not-hit",
      reactionTime: 0,
      tapDuration: 0,
    });
    next();
  };

  return {
    ...stateProps,
    ...otherProps,
    onStart: handleStart,
    onTimeout: handleTimeout,
    onHit: handleHit,
  };
};

const OneBackPresentation = connect(
  stateToProps,
  dispatchProps,
  mergeProps
)(TestsPresentationComponent);

export default OneBackPresentation;
